import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MHCQ';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';


//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";
import Tab4 from './Tab4';
import SelectOption from '../../../SelectOption';
import DataSelect from '../../../../Types/DataSelect';


const dataOption: DataSelect[] = [
    { label: "CHEQUE GUICHET", value: "G" },
    { label: "CHEQUE CLIENT", value: "C" }
]

const dataOption2: DataSelect[] = [
    { label: "CG", value: "CG" },
    { label: "CC", value: "CC" }
]

const CreateCHQ = () => {

    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(true)
    const [donnees, setData] = useState<DataType[]>([]);
    const [sbmit, setSbmit] = useState("");
    const authHeader = useAuthHeader();
    const [NUMDEM, setNumdem] = useState(false)
    const [IDNUMDEM, setIdNumdem] = useState("");
    const [Val, setVal] = useState<number>(10);

    let searchDmandCHQ: ParamsPicklist = { CodeAgence: Perss.codage, Table: "DEMANDECHQ", Colonne1: "NUMDEMANDE", Colonne2: "NOMCPT", Colagence: 'codeage',colfiltre: "", valfiltre: '', Choix: 22 }



    // usestate
    function HandleAnnul() {
        setNumdem(false);
        form.resetFields();
        localStorage.clear();
    }



    const Getselectcli = (value: any) => {
        setNumdem(true);
        setIdNumdem(form.getFieldValue("NUMDEMANDE"));
        consult();
    }

    // Gestion des Items 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Mise en place Chéquier
                </span>
            ),
            children: <>

                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <Box fontStyle="inherit" className='border-left'>

                                <legend> Mise en place d'un chèque </legend>
                                <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                    <Box style={{ display: 'flex' }}>
                                        <Box style={{ width: '50%' }}>
                                            <Box style={{ marginTop: 0 }}>
                                                <SearchModal width={6} disabled={NUMDEM} Parametre={searchDmandCHQ} ExecuteafterSelect1={Getselectcli} Titre="" label="ID Demande" name="NUMDEMANDE" Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={6} disabled={true} Titre="" label="ID client" name="NUMCLI" Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={6} disabled={true} Titre="" label="N° compte" name="NUMCPT" Taille1={'100%'} Taille2={'100%'} form={form} />
                                            </Box>
                                        </Box>
                                        <Box style={{ width: '50%' }}>
                                            <Box style={{ marginTop: 0, width: '100%' }}>
                                                <InputForm width={7} disabled={true} label="Nombre de chéquier" type="number" name="nbr" />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <InputForm disabled={true} width={7} label="Nombre de chèque" type="number" name="NBCHQS" />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <InputForm disabled={true} width={7} label="Total commission" type="number" name="COMMIS" />
                                            </Box>
                                        </Box>
                                    </Box>
                                </fieldset>

                                <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                    <Box style={{ display: 'flex', marginTop: 0 }}>
                                        <Box style={{ width: '40%' }}>
                                            <Form.Item style={{ width: '100%', marginTop: -5, marginBottom: -15 }} >
                                                < SelectOption Option={dataOption} width={10} label='Type de chèque' Size={'100%'} name='TYPCHQ' />
                                            </Form.Item>
                                            <Box style={{ marginTop: 0, width: '100%' }}>
                                                <InputForm width={10} onChange={CalculFin} label="N° dèbut chèque" type="number" name="NUMCHQ" /> 
                                            </Box>
                                        </Box>
                                        <Box style={{ width: '50%' }}>
                                            <Box style={{ width: '100%', marginTop: -5, paddingLeft: 0 }}>
                                                {/* <InputForm width={7} label="Serie de chèque" type="texte" name="SERCHQ" /> */}
                                                < SelectOption Option={dataOption2} width={7} label='Serie de chèque' Size={'100%'} name='SERCHQ' />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <InputForm disabled={true} width={7} label="N° chèque Fin" type="number" name="CHFIN" />
                                            </Box>
                                        </Box>
                                    </Box>
                                </fieldset>

                            </Box>
                        </Box>
                    </div>
                </div >


            </>
        },
    ];

    // function consult 
    function consult() {


        if (form.getFieldValue("NUMDEMANDE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
            //HandleAnnul();
        } else {

            let data = Crypter.encrypt(form.getFieldValue("NUMDEMANDE"));
            let codeage = Crypter.encrypt(Perss.codage)
            //alert(form.getFieldValue("NUMDEMANDE"))
            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadDemandCHQ,
                    headers: {
                        'CypherREFMARQ': data,
                        'CypherCodeage': codeage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            if (res.Result == null) {
                                SweetAlert.fire({ title: "Warning", text: 'la Référence appartient a une agence distante', icon: "warning" });
                                HandleAnnul()
                            } else {
                                let DemandCHQ = res.Result.Table[0];
                                if (res.StatutCode == 200) {
                                    form.setFieldsValue(DemandCHQ);
                                    form.setFieldValue("lib_NUMDEMANDE", DemandCHQ.NOMCPT);
                                    form.setFieldValue("lib_NUMCLI", DemandCHQ.NOMCPT);
                                    form.setFieldValue("nbr", 1);
                                    form.setFieldValue("COMMIS", DemandCHQ.MONTAN1 + DemandCHQ.MONTAN2);
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" });
                    });
            }
        }
    }



    // function Onfinish
    const onFinish = (values: any) => {

        if (form.getFieldValue("NUMDEMANDE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
            HandleAnnul();
        } else {

            console.log(values)
            var DemandHCQ: Demand = values
            DemandHCQ.DATSAI = formatDate(Perss.datjour);
            DemandHCQ.datcre = DemandHCQ.DATSAI;
            DemandHCQ.DATPAI = DemandHCQ.DATSAI;
            DemandHCQ.DATVAL = DemandHCQ.DATSAI;
            DemandHCQ.AGCCPT = Perss.codage;
            DemandHCQ.UTILIS = Perss.coduti;
            DemandHCQ.UTIVAL = '';
            //DemandCHQ.DATDEM = formatDate(Perss.datjour);
            //DemandCHQ.codeage = Perss.codage;

            SweetAlert.fire({
                title: "Mise en place d'un chequier",
                text: "Voulez-vous Créer le chequier de :" + values.lib_NUMCPT + " ?",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    console.log((DemandHCQ))
                    let data = Crypter.encrypt(JSON.stringify(DemandHCQ));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateHCQ,
                        headers: {
                            'CypherDEMANDCHQ': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {

                                    let code = res.Result


                                    if (code == "ErreurDemande") {
                                        //HandleEnreg();
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul();
                                        SweetAlert.fire({ title: 'warning', text: "Le chèquier de la demande est déja créer", icon: "warning" })

                                    } else if (code == "NotEnd") {
                                        //HandleEnreg();
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul();
                                        SweetAlert.fire({ title: 'warning', text: "Le membre possède des chèques valides", icon: "warning" })

                                    } else if (code == "ChqErreur") { // ErreurPlage
                                        //HandleEnreg();
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul();
                                        SweetAlert.fire({ title: 'warning', text: "certains Numèros de chèque appartiennent a un autre chequier", icon: "warning" })

                                    } else if (code == "Effectuer avec succès") {
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul();
                                        SweetAlert.fire({ title: res.Message, text: "Mise En Place " + code, icon: "success" })

                                    } else if (code == "ErreurJr") {
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul();
                                        SweetAlert.fire({ title: 'warning', text: "Impossible de faire la Mise en Place du Chéquier car la Journée Comptable n'est pas Ouverte " + code, icon: "success" })

                                    } else {

                                        SweetAlert.fire({ title: 'warning', text: "Impossible Car certain(s) chéquié(s) sont déjà Utilisé(s), telsque:" + code, icon: "warning" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }



    // function 
    function CalculFin() {

        var number1 = parseInt(form.getFieldValue("NUMCHQ"));
        var number2 = parseInt(form.getFieldValue("NBCHQS"));

        number1 = number1 + number2;
        form.setFieldValue("CHFIN", number1 - 1);
    }



    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={false} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>

                                <Button size='large' className='bt_add' disabled={false} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' disabled={false} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            {/*
                            <div className='tabItem' >

                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border-left '>
                                        </Box>
                                    </Box>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}


export default CreateCHQ;